import axios from "axios";
import React, { Component,useEffect } from "react";
import { connect } from "react-redux";
import {Link} from "react-router-dom";
import {set_datapage} from '../../redux/actions/DataPageAction'
import { baseUrl,localUrl } from "@ora/recursos/src/helpers/Url";
import qs from 'query-string'
import { Chart } from "react-google-charts";
import $ from 'jquery'

import dt from 'datatables.net'
import "css/reportes/scrollbar.css";
import typeahead from 'corejs-typeahead'

import {PageLength} from "helpers/Datatables";
$.DataTable = dt
$.typeahead = typeahead


class Comercio extends Component {
    filter = {
        buscar: '' 
    }
    table=null
    datatable=null
    constructor (props) {
        super(props)
        this.props.set_datapage({ titulo: 'Comercio CITES',
                                isbackend:false,
                                be_itemselect:"comercio_cites",//clave de item del menu backend que se debe activar 
                                breadcrumb:[
                                    {name:"Inicio",url:localUrl("/")},
                                    {name:"Reportes",url:"#"},
                                    {name:"Comercio CITES",url:"#",active:true},
                                ]});
        this.state = {
            lista: false,
            cites: false,
            iucn: false,
            paises: false,
            recursos: false,
            tiporecurso:false,
            search:{txt_ncc:"",sel_year: "", sel_iucn: "",sel_recurso: "",sel_tiporecurso: "",sel_pais: ""} ,
            filter : {},
            regpag:process.env.REG_PAG,
            dataLoadingStatus: 'loading',
            // dataLoadingStatus: 'ready',
            chartData: [],
            total:0
          };
       
    }
   
    initTypeahead =  () => {

        // $('#txt_ncc').typeahead({
        // hint: true,
        // highlight: true,
        // minLength: 1
        // },
        // {
        // name: 'states',
        // source: substringMatcher(states)
        // });
        // var _this = this
      
        const fnTargetText = (e, data) => {
            
            this.setState({          
                search: {
                    ...this.state.search,
                    txt_ncc: data.text
                }
            })

            
        }
        $('#txt_ncc').typeahead({
            highlight: true,
            hint: false,
            minLength: 1
            }, {
            async: true,
            name: 'search-exportaciones',
            display: function display(d) {
                return d.text;
            },
            templates: {
                suggestion: h => {
                    if (h.asPlaceholder !== undefined) {
                        return `<div>Solo buscar <b>"${h.text}"</b></div>`
                    } else 
                        return `<div>${h.text}</div>`
                }
            },
            source: function source(q, cb, asy) {
                // let result = []
                if (q.trim() != '') {
                // var no_buscar = _this.cilindros.map(function (v) {
                //     return v.id;
                // });
                // console.log(no_buscar);
                // axios.get(BASE_URL + '/api/cilindro?m=all&q=' + q, {params: {cilindros: no_buscar}}).then(res => {
                cb([{count: 0, asPlaceholder: true, text: q.trim()}]);
                axios.get(baseUrl('cites/exportaciones/typeahead'), {
                    params: { q: q.trim() } 
                }).then(function (res) {
                    // console.log(res.data)
                    // return res.data
                    // res.data.unshift({count: 0, text: `Solo buscar "${q.trim()}"` })
                    asy(res.data);
                    // return res.data
                });

                // let regex = new RegExp(q, 'i');
                // cb(_this.listaBancos.filter(v => {
                //   return regex.test(v.banco_name)
                // }))
                }
            }
            }).bind('typeahead:select', fnTargetText).bind('typeahead:autocomplete', fnTargetText);
    }
    componentDidMount() {
        var params=qs.parse(this.props.location.search)
        var url=baseUrl(`cites/reportes/initcomercio?l=25&o=0`)

        
        var search=this.state.search
        if((params["q1"])){
            search['txt_ncc']=params["q1"]
            url+="&q1="+params["q1"]

        }
        if((params["q2"])){
            search['sel_year']=params["q2"]
            url+="&q2 n="+params["q2"]

        }
        if((params["q3"])){
            search['sel_iucn']=params["q3"]
            url+="&q3="+params["q3"]

        }
        if((params["q4"])){
            search['sel_tiporecurso']=params["q4"]
            url+="&q4="+params["q4"]

        }
        this.setState({
            search: search            
        })
        this.setFilter()
        axios.get(url).then(res => {
            this.initpage(res.data);
        })
    }

    setFilter(){
        this.setState({
            filter : {
                q1: this.state.search['txt_ncc'],
                q2: this.state.search['sel_year'],
                q3: this.state.search['sel_iucn'],
                q4: this.state.search['sel_tiporecurso']
            }
        })
    }


    initpage(result){
        var resultados = result;        
        console.info("%c--- get reporte ", "color:yellow;background:green");
        var search=this.state.search
        const itemYear= resultados.year.map((item, index) => {
            var selected=false
            if(this.state.search['sel_year']==item.exp_int_year){search["sel_year"]=item.exp_int_year;selected=true}
            return (
                <option ke={ index } value={item.exp_int_year} selected={selected}>{item.exp_int_year}</option>
            );
        })
        const itemPaises= resultados.paises.map((item, index) => {
            var selected=false
            if(this.state.search['sel_iucn']==item.name){search["sel_iucn"]=item.name;selected=true}
            return (
                <option key={ index } value={item.code} selected={selected}>{item.name}</option>
            );
        })
      
        this.setState({
            year: itemYear,
            paises: itemPaises,
            search:search        
        })
        this.getSearch()
       
        
    }
    initDatatable = () => {
        

        const OnClick_acciones = (evt) => {
             let {accion, id} = evt.currentTarget.dataset
            switch (accion) {
                case 'ver':
                this.props.history.push(localUrl("/reportes/comercios/" + id))
                break;
            }
        }
        this.configDT =  {
            data: [],
            dom: "<'columns'<'column is-full'<'table-container't>>><'columns p-4'<'column'l><'column'p>>",
            processing: true,
            pageLength:PageLength(),
            ajax: {
              url: baseUrl("cites/reportes/comercio_datatable?l=25&o=0&tq=1"),
              data: (d) => {
                
                d.filter = {
                    q1: this.state.search['txt_ncc'],
                    q2: this.state.search['sel_year'],
                    q3: this.state.search['sel_iucn'],
                    q4: this.state.search['sel_tiporecurso'],
                }
                return d
              },
            },
            serverSide: true,
            order: [[0, "asc"]],
            createdRow: (r, d, i) => {
            },
            columns: [
              { data: "exp_int_id" },
              { data: "exp_int_year" },
              { data: "exp_txt_taxon" },
              { data: "exp_txt_term" },
              { data: "exp_int_quantity" },
              { data: "exp_txt_unit" },
              { data: "pais_exporter" },
              { data: "pais_importer" },
              { data: "exp_int_id", render: (d, t, r) => {
                  return `
                  <div class="buttons is-centered">
                  <button data-id="${d}" data-accion="ver" class="button is-small is-primary btn-acciones" title="Ver">
                      <span class="icon is-small"><i class="fas fa-eye"></i></span>
                  </button>
              </div>
                    `
              } }
            ],
            drawCallback: () => {
                
                $('#tblComercio_paginate a.previous').addClass("pagination-link pagination-previous");
                $('#tblComercio_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblComercio_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblComercio_paginate span a.paginate_button.current').addClass("pagination-link is-current");
                $('#tblComercio_paginate span a.paginate_button').addClass("pagination-link");
         
              }
        }
        this.table = $('#tblComercio')
        
        // setTimeout(() => {
            
            this.datatable = this.table.DataTable(this.configDT).on('click', '.btn-acciones', OnClick_acciones)

        // }, 20000)
    }
   
    cargarregistros(datos){
        const listaItems = datos.registros.map((item,index) => {
            return (             
               <tr key={"registro_" + item.exp_int_id}>
               <td className="is-checkbox-cell">
                   {index+1}                               
               </td> 
               <td >{item.exp_int_year}</td>                              
               <td >{item.exp_txt_taxon}</td>
               <td>{item.exp_txt_term}</td>
               <td >{item.exp_int_quantity}</td>
               <td >{item.exp_txt_unit}</td>
               <td>{item.pais_exporter}</td>
               <td>{item.pais_importer}</td>
               <td className="is-actions-cell">
               <div className="buttons is-right">
               <Link className="button is-small is-primary"  to={localUrl("/reportes/comercios/"+item.exp_int_id)}>
               <span className="icon"><i className="mdi mdi-eye"></i></span>
               </Link>
               </div>
               </td>
               </tr>
            );
          });
          this.setState({
            lista: listaItems,
            total:datos.total
        })
    }
    cargarchartyear(datos){
        let year = [
            ['Años', 'Cantidad']       
        ]
        datos.yearchart.map((item,index) => {
        //console.log(datos.yearchart)
        year.push([item.exp_int_year,parseInt(item.cantidad)])
          });
          this.setState({
            yearChart: year,
            dataLoadingStatus: 'ready'
        })
        this.initTypeahead()
        this.initDatatable()
    }
    cargarchartappendice(datos){
        let appendice = [
            ['Task', 'Hours per Day']       
        ]
        datos.appendicechart.map((item,index) => {
        //console.log(datos.yearchart)
        appendice.push([item.exp_txt_appendix,parseInt(item.cantidad)])
          });
          this.setState({
            appendiceChart: appendice
        })
    }
    cargarchartexporter(datos){
        let exportador = [
            ['Task', 'Hours per Day']       
        ]
        datos.exporterchart.map((item,index) => {
        //console.log(datos.yearchart)
        exportador.push([item.pais_exporter,parseInt(item.cantidad)])
          });
          this.setState({
            exportadorChart: exportador
        })
    }
    cargarchartimporter(datos){
        let importador = [
            ['Task', 'Hours per Day']       
        ]
        datos.importerchart.map((item,index) => {
        //console.log(datos.yearchart)
        importador.push([item.pais_importer,parseInt(item.cantidad)])
          });
          this.setState({
            importadorChart: importador
        })
    }
    cargarchartespecie(datos){
        let especie = [
            ['Especie', 'Cantidad']       
        ]
        datos.especiechart.map((item,index) => {
        //console.log(datos.yearchart)
        especie.push([item.exp_txt_taxon,parseInt(item.cantidad)])
          });
          this.setState({
            especieChart: especie
        })
    }

    buscar_simple = () => {
        this.datatable.destroy();
        this.getSearch();
        var url=this.getParamsUrl("/reportes/comercio?");  
        this.props.history.push(localUrl(url))       
    }
    getSearch(){
        var url=this.getParamsUrl("cites/reportes/comercio?l=25&o=0&tq=1"); 
        url=baseUrl(url)
       
        axios.get(url).then(res => {
            // this.datatable = this.table.DataTable(this.configDT)
            
            //console.log(res.data.datos)
            this.cargarregistros(res.data.datos);
            this.cargarchartyear(res.data.datos);
            this.cargarchartappendice(res.data.datos);
            this.cargarchartexporter(res.data.datos);
            this.cargarchartimporter(res.data.datos);
            this.cargarchartespecie(res.data.datos);
        })
           

    }
    getParamsUrl(url){
        if(this.state.search['txt_ncc']!=""){
            url+="&q1="+this.state.search['txt_ncc']

        }
        if(this.state.search['sel_year']!=""){
            url+="&q2="+this.state.search['sel_year']

        }
        if(this.state.search['sel_iucn']!=""){
            url+="&q3="+this.state.search['sel_iucn']

        }
        if(this.state.search['sel_tiporecurso']!=""){           
            url+="&q4="+this.state.search['sel_tiporecurso']

        }
        return url;

    }

    ir_detalle = (e) => {
        const { especie } = e.target.dataset;
        var url="/reportes/fichaespecie/"+especie
        this.props.history.push(localUrl(url)) 
        
    }

    gestionarCambio = (event) => {
        var search=this.state.search
        if (event.target.type === "radio") {
            search[event.target.name]=event.target.value;
        } else {
            search[event.target.id]=event.target.value;
        }
        this.setState({          
            search:search
        })
      };


    render() {
        return this.state.dataLoadingStatus === 'ready' ?(
            <div>
                <section className="section is-main-section">
                <div className="card">
                    <header className="card-header">
                        <p className="card-header-title">
                        Filtro
                        </p>
                       
                    </header>
                    <div className="card-content">
                        <div className="field is-horizontal">
                            <div className="field-body">
                                   <div className="field">
                                       <label className="label">Nombre cientifico</label>
                                       <div className="control">
                                           <input className="input is-expanded" id="txt_ncc" size="50" type="text" autoComplete="off" placeholder="Ingrese nombre cientifico o común"  onChange={this.gestionarCambio} value={this.state.search.txt_ncc}></input>
                                       </div>
                                   </div>
                                   <div className="field">
                                       <label className="label">Año</label>
                                       <div className="control">
                                           <div className="select">
                                           <select id="sel_year"  onChange={this.gestionarCambio}>
                                               <option value="">--Seleccione--</option>
                                               {this.state.year}                                                          
                                           </select>
                                           </div>
                                       </div>
                                   </div>
                                   <div className="field ">
                                       <label className="label">Pais Exportador</label>
                                       <div className="control">
                                           <div className="select">
                                           <select id="sel_iucn"  onChange={this.gestionarCambio}>
                                               <option value="">--Seleccione--</option>
                                               {this.state.paises}                                                           
                                           </select>
                                           </div>
                                       </div>
                                   </div>
                                   <div className="field ">
                                       <label className="label">Pais Importador</label>
                                       <div className="field is-grouped">
                                        <div className="control">
                                            <div className="select">
                                            <select id="sel_tiporecurso"  onChange={this.gestionarCambio}>
                                                <option value="">--Seleccione--</option>
                                                {this.state.paises}                                                           
                                            </select>
                                            </div>
                                        </div>
                                        <p className="control">
                                            <button className="button is-link" onClick={this.buscar_simple}>Buscar</button>
                                        </p>
                                       </div> 
                                   </div> 
                            </div>           
                        </div>
                    </div>
                    
                </div>
                <div className="card">
                    <header className="card-header">
                        <p className="card-header-title">
                        Resumen
                        </p>
                       
                    </header>
                    <div className="card-content">
                        <div className="field is-horizontal">
                            <div className="field-body">
                                    <Chart
                                            width={'550px'}
                                            height={'300px'}
                                            chartType="BarChart"
                                            loader={<div>Loading Chart</div>}
                                            data={this.state.yearChart}
                                            options={{
                                                // Material design options
                                                //legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                                                legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                                                title: 'Exportaciones por Año',
                                                chart: {
                                                title: 'Exportaciones por Año'
                                                },
                                                vAxis: {
                                                    minValue: 0,
                                                    maxValue: 1000
                                                }
                                            }
                                            
                                        }
                                            // For tests
                                            rootProps={{ 'data-testid': '2' }}
                                            />
                            </div> 
                            <div className="field-body">
                            <Chart
                                    width={'700px'}
                                    height={'300px'}
                                    chartType="BarChart"
                                    loader={<div>Loading Chart</div>}
                                    data={this.state.especieChart}
                                    options={{
                                        // Material design options
                                        //legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                                        legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                                        title: 'Cantidad de Exportaciones por Especie',
                                        chart: {
                                      
                                        },
                                        vAxis: {
                                            minValue: 0,
                                            maxValue: 1000
                                          }
                                    }
                                    
                                }
                                    // For tests
                                    rootProps={{ 'data-testid': '2' }}
                                    />
                               
                            </div>
                        </div>
                        <div className="field is-horizontal">
                            <div className="field-body">
                                <Chart
                                            width={'420px'}
                                            height={'280px'}
                                            chartType="PieChart"
                                            loader={<div>Loading Chart</div>}
                                            data={this.state.appendiceChart}
                                            options={{
                                                title: 'Apendices',
                                                legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                                                pieSliceText: 'percentage',
                                            
                                                pieStartAngle: 100,
                                            }}
                                            rootProps={{ 'data-testid': '2' }}
                                            />
                            </div>
                            <div className="field-body">
                                 <Chart
                                            width={'420px'}
                                            height={'280px'}
                                            chartType="PieChart"
                                            loader={<div>Loading Chart</div>}
                                            data={this.state.exportadorChart}
                                            options={{
                                                title: 'Paises Miembros Exportadores',
                                                legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                                                pieSliceText: 'percentage',
                                            
                                                pieStartAngle: 100,
                                            }}
                                            rootProps={{ 'data-testid': '3' }}
                                            />
                            </div>
                            <div className="field-body">
                                <Chart
                                            width={'420px'}
                                            height={'280px'}
                                            chartType="PieChart"
                                            loader={<div>Loading Chart</div>}
                                            data={this.state.importadorChart}
                                            options={{
                                                title: 'Paises Miembros Importadores',
                                                legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                                                pieSliceText: 'percentage',
                                            
                                                pieStartAngle: 100,
                                            }}
                                            rootProps={{ 'data-testid': '2' }}
                                            />
                            </div>
                        </div>
                        
                        
                    </div>
                    
                </div>
                    <div className="card has-table">                  
                        <div className="notification is-card-toolbar">
                            <div className="level">
                            <div className="level-left">
                                <div className="level-item">
                                    <strong>Lista de resultados</strong> 
                                </div>
                                
                            </div>
                            <div className="level-right">
                                <div className="level-item">
                                    {this.state.total} registros                            
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="card-content">
                            <a class="button is-primary" href={baseUrl('cites/reportes/getexcel?c=getImportacionesCitesDT&filter')+JSON.stringify(this.state.filter)}>Exportar a Excel</a>
                           
                            <div className="b-table has-pagination">
                                <div className="table-wrapper has-mobile-cards">
                                    <table id="tblComercio" className="table is-fullwidth is-striped is-hoverable is-fullwidth">
                                        <thead>
                                        <tr>
                                            <th> # </th>
                                            <th>Año</th>
                                            <th>Taxon</th>
                                            <th>Term</th>
                                            <th>Cantidad</th>
                                            <th>Unidad</th>
                                            <th>Exportador</th>
                                            <th>Importador</th>   
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                                 
                                        </tbody>
                                  
                                    </table>
                                </div>
                                 {/* <div className="notification">
                                    <div className="level">
                                    <div className="level-left">
                                        <div className="level-item">
                                        <div className="buttons has-addons">
                                            <button type="button" className="button is-active">1</button>
                                            <button type="button" className="button">2</button>
                                            <button type="button" className="button">3</button>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="level-right">
                                        <div className="level-item">
                                        <small>Page 1 of 3</small>
                                        </div>
                                    </div>
                                    </div>
                                </div>  */}
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        ):(
            
                
            <div className="columns is-justify-content-center mb-6">
                <div className="field is-horizontal">
                    <div className="field-body">
                        <div  className="field pt-2">
                            <div ref={ this.spinnerLoad } className="ld ld-spinner  ld-spin">
                            </div>
                        </div>
                        <div  className="field">
                             <h2 className="tamano is-2"> Cargando... </h2>
                        </div>
                    </div>
                    
                </div>
            
            
            
            </div>
  
        )
    }
}


export default connect(null, {set_datapage})(Comercio)